import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ManageSellerService {

  constructor(private _http: HttpClient) { }

  manageseller(data) {
    return this._http.post(environment.api_url+'admin/sellerrecords/verified',data);
  }

  registeredseller(data) {
    return this._http.post(environment.api_url+'admin/sellerrecords/unverified',data);
  }

    updatestatus(data) {
        return this._http.post(environment.api_url+'admin/user/updatestatus',data);
    }

}
